export enum LocalStorageItemKey {
  selectedClientId = 'selectedClientId',
  selectedStoreId = 'selectedStoreId',
}
